// extracted by mini-css-extract-plugin
export var bodySections = "_7f-8";
export var gray = "_7f-7";
export var green = "_7f-4";
export var iconContainer = "_7f-9";
export var iconWidgetContainer = "_7f-1";
export var phoneIcon = "_7f-2";
export var red = "_7f-5";
export var statusDot = "_7f-3";
export var widgetContainer = "_7f-0";
export var yellow = "_7f-6";